module.exports = __webpack_public_path__ + "img/weekly_menu_icon.8dec464b.svg";